import london from '../images/london.jpg'
import edin from '../images/edinburgh.jpg'
import bristol from '../images/bristol.jpg'
import manchester from '../images/manchester.jpg'
import Bath from '../images/Bath.jpg'
const data = [
  
    {
      "index":"1",
      "city": "London",
      "eventtype": "Walking Tour",
      "description": "Explore the historic streets of London with a knowledgeable guide. Discover hidden gems and iconic landmarks on this unforgettable journey.",
      "left": "9 spots left!",
      "link": "#london",
      "image":london
    },
    {
      "index":"2",
      "city": "Bath",
      "eventtype": "Live Music Gig",
      "description": "Immerse yourself in Glasgow's vibrant music scene. Experience the energy of live performances in iconic venues across the city.",
      "left": "8 spots left!",
      "link": "#bath",
      "image":Bath
    },
    {
      "index":"3",
      "city": "Edinburgh",
      "eventtype": "Ghost Tour",
      "description": "Embark on a spine-chilling adventure through the haunted streets of Edinburgh. Hear tales of ghosts, witches, and eerie legends.",
      "left": "10 spots left!",
      "link": "#edinburgh",
      "image":edin
    },
    {
      "index":"4",
      "city": "Bristol",
      "eventtype": "Street Art Workshop",
      "description": "Unleash your creativity in Bristol's vibrant street art scene. Learn techniques from local artists and leave your mark on the city's walls.",
      "left": "9 spots left!",
      "link": "#bristol",
      "image": bristol
    },
    {
      "index":"5",
      "city": "Manchester",
      "eventtype": "Football Stadium Tour",
      "description": "Get behind the scenes at Manchester's iconic football stadiums. Walk in the footsteps of legends and experience the thrill of match day.",
      "left": "9 spots left!",
      "link": "#manchester",
      "image": manchester
    },
    
    {
      "index":"6",
      "city": "Cambridge",
      "eventtype": "Punting Tour",
      "description": "Drift along the peaceful River Cam and admire the stunning architecture of Cambridge's colleges. A serene and picturesque experience awaits.",
      "left": "9 spots left!",
      "link": "#cambridge",
      "image":"https://upload.wikimedia.org/wikipedia/commons/b/b4/KingsCollegeChapelWest.jpg"
    }
  
];

export default data;
